import { render, staticRenderFns } from "./VbgQuickLinks.vue?vue&type=template&id=2649f686&scoped=true"
import script from "./VbgQuickLinks.vue?vue&type=script&lang=js"
export * from "./VbgQuickLinks.vue?vue&type=script&lang=js"
import style0 from "./VbgQuickLinks.vue?vue&type=style&index=0&id=2649f686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2649f686",
  null
  
)

export default component.exports